import React, { useState, useMemo } from "react";
import "./Referral.css";

const formatter = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
});

const formatMoney = (value) => formatter.format(Number(value || 0));

const defaultCostItems = [
  { key: "brokerFee", label: "Broker’s Fee", value: "" },
  { key: "deedPrep", label: "Preparation of Deed", value: "" },
  { key: "transferTax", label: "Transfer Tax", value: "" },
  { key: "sellerClosingConcession", label: "Seller Concession: Closing Costs", value: "" },
  { key: "sellerBuyerBrokerConcession", label: "Seller Concession: Buyer Broker Fee", value: "" },
  { key: "homeWarranty", label: "Home Warranty", value: "" },
  { key: "municipalCertifications", label: "Municipal Certification(s)", value: "" },
  { key: "resaleCertificate", label: "Certificate of Resale / HOA / Condo", value: "" },
  { key: "settlementFee", label: "Settlement Fee", value: "" },
  { key: "notaryFees", label: "Notary Fees", value: "" },
  { key: "survey", label: "Survey", value: "" },
  { key: "sewagePumping", label: "On-lot Sewage System Pumping", value: "" },
  { key: "propertyRepairs", label: "Property Repairs", value: "" },
  { key: "taxCertifications", label: "Tax Certifications", value: "" },
  { key: "overnightMail", label: "Overnight / Express Mail Charges", value: "" },
  { key: "domesticLienSearch", label: "Domestic Lien Search", value: "" },
  { key: "patriotActSearch", label: "Patriot Act Search", value: "" },
  { key: "other1", label: "Other", value: "" },
  { key: "other2", label: "Other", value: "" },
];

export default function EstimatedCostCalculator() {
  const [property, setProperty] = useState("");
  const [seller, setSeller] = useState("");
  const [buyer, setBuyer] = useState("");
  const [settlementDate, setSettlementDate] = useState("");
  const [purchasePrice, setPurchasePrice] = useState("");

  const [costItems, setCostItems] = useState(defaultCostItems);
    const [adjustments, setAdjustments] = useState([
    { type: "real estate taxes", amount: "" },
    ]);

    const [loanPayoffs, setLoanPayoffs] = useState([
    { label: "Seller's Estimate of Mortgages", amount: "" },
    { label: "Equity", amount: "" },
    {
        label:
        "Other Loan Balances, liens, assessments, etc.",
        amount: "",
    },
    ]);

  const updateCostItem = (key, value) => {
    setCostItems((prev) =>
      prev.map((item) =>
        item.key === key ? { ...item, value } : item
      )
    );
  };

  const addAdjustment = () => {
    setAdjustments((prev) => [
        ...prev,
        { type: "real estate taxes", amount: "" },
    ]);
    };

    const removeAdjustment = (index) => {
    setAdjustments((prev) => prev.filter((_, i) => i !== index));
    };

    const updateAdjustment = (index, field, value) => {
    setAdjustments((prev) =>
        prev.map((item, i) =>
        i === index ? { ...item, [field]: value } : item
        )
    );
    };

    const updateLoanPayoff = (index, value) => {
    setLoanPayoffs((prev) =>
        prev.map((item, i) =>
        i === index ? { ...item, amount: value } : item
        )
    );
    };

const results = useMemo(() => {
  const estimatedCostsSubtotal = costItems.reduce(
    (sum, item) => sum + Number(item.value || 0),
    0
  );

  const adjustmentsTotal = adjustments.reduce(
        (sum, item) => sum + Number(item.amount || 0),
        0
    );

    const totalEstimatedCostsAdjustments =
        estimatedCostsSubtotal + adjustmentsTotal;

    const estimatedProceedsBeforeLoanPayoffs =
        Number(purchasePrice || 0) - totalEstimatedCostsAdjustments;

    const loanPayoffsTotal = loanPayoffs.reduce(
        (sum, item) => sum + Number(item.amount || 0),
        0
    );

    const estimatedNetProceedsToSeller =
        estimatedProceedsBeforeLoanPayoffs - loanPayoffsTotal;

    return {
        estimatedCostsSubtotal,
        adjustmentsTotal,
        totalEstimatedCostsAdjustments,
        estimatedProceedsBeforeLoanPayoffs,
        loanPayoffsTotal,
        estimatedNetProceedsToSeller,
    };
    }, [costItems, adjustments, purchasePrice, loanPayoffs]);

  return (
  <div className="referral-container">
    <h1>Seller’s Estimated Costs</h1>

    <form>
      <h2 className="referral-header-space">PROPERTY INFORMATION</h2>

      <input
        placeholder="Property"
        value={property}
        onChange={(e) => setProperty(e.target.value)}
      />

      <input
        placeholder="Seller"
        value={seller}
        onChange={(e) => setSeller(e.target.value)}
      />

      <input
        placeholder="Buyer"
        value={buyer}
        onChange={(e) => setBuyer(e.target.value)}
      />

      <div className="referral-row">
        <input
          type="date"
          value={settlementDate}
          onChange={(e) => setSettlementDate(e.target.value)}
        />

        <input
          type="number"
          placeholder="Purchase Price"
          value={purchasePrice}
          onChange={(e) => setPurchasePrice(e.target.value)}
        />
      </div>

      <h2 className="referral-header-space">ESTIMATED COSTS</h2>

      <div className="broker-sections">
        <div className="broker-column">
          {costItems.slice(0, Math.ceil(costItems.length / 2)).map((item) => (
            <input
              key={item.key}
              type="number"
              placeholder={item.label}
              value={item.value}
              onChange={(e) => updateCostItem(item.key, e.target.value)}
            />
          ))}
        </div>

        <div className="broker-column">
          {costItems.slice(Math.ceil(costItems.length / 2)).map((item) => (
            <input
              key={item.key}
              type="number"
              placeholder={item.label}
              value={item.value}
              onChange={(e) => updateCostItem(item.key, e.target.value)}
            />
          ))}
        </div>
      </div>

      <h2 className="referral-header-space">ADJUSTMENTS (+/-)</h2>

        {adjustments.map((item, index) => (
        <div className="referral-row" key={index}>
            <select
            value={item.type}
            onChange={(e) => updateAdjustment(index, "type", e.target.value)}
            >
            <option value="real estate taxes">Real Estate Taxes</option>
            <option value="association fees">Association Fees</option>
            <option value="utilities">Utilities</option>
            <option value="other">Other</option> 
            </select>

            <input
            type="number"
            placeholder="Amount"
            value={item.amount}
            onChange={(e) => updateAdjustment(index, "amount", e.target.value)}
            />

            <button type="button" onClick={addAdjustment}>
            +
            </button>

            {adjustments.length > 1 && (
            <button type="button" onClick={() => removeAdjustment(index)}>
                -
            </button>
            )}
        </div>
        ))}

        <h2 className="referral-header-space">
        ESTIMATED PROCEEDS BEFORE LOAN PAYOFFS
        </h2>

        <p>Purchase Price: {formatMoney(purchasePrice)}</p>

        <p>
        Total Estimated Costs / Adjustments from above:{" "}
        {formatMoney(results.totalEstimatedCostsAdjustments)}
        </p>

        <h2>
        Estimated Proceeds Before Loan Payoffs:{" "}
        {formatMoney(results.estimatedProceedsBeforeLoanPayoffs)}
        </h2>

        <h2 className="referral-header-space">
        ESTIMATED NET PROCEEDS TO SELLER
        </h2>

        {loanPayoffs.map((item, index) => (
        <div key={index}>
            <label>{item.label}</label>
            <input
            type="number"
            placeholder="Amount"
            value={item.amount}
            onChange={(e) => updateLoanPayoff(index, e.target.value)}
            />
        </div>
        ))}

        <p>
        Total Mortgage / Loan Payoffs:{" "}
        {formatMoney(results.loanPayoffsTotal)}
        </p>

        <h2>
        Estimated Net Proceeds to Seller:{" "}
        {formatMoney(results.estimatedNetProceedsToSeller)}
        </h2>

      <h2 className="referral-header-space">SUMMARY</h2>

      <p>Purchase Price: {formatMoney(purchasePrice)}</p>
      <p>Estimated Costs Subtotal: {formatMoney(results.estimatedCostsSubtotal)}</p>
      <p>Adjustments: {formatMoney(adjustments)}</p>
      <p>
        <strong>
          Total Estimated Costs / Adjustments:{" "}
          {formatMoney(results.totalEstimatedCostsAdjustments)}
        </strong>
      </p>

      <p>
        Estimated Proceeds Before Loan Payoffs:{" "}
        {formatMoney(results.estimatedProceedsBeforeLoanPayoffs)}
      </p>

      <p>Loan Payoffs: {formatMoney(loanPayoffs)}</p>

      <h2>
        Estimated Net Proceeds to Seller:{" "}
        {formatMoney(results.estimatedNetProceedsToSeller)}
      </h2>
    </form>
  </div>
);
}